export enum DogEarType {
  LOCKED = 'locked',
  FOLLOW_GATED = 'follow gated',
  USDC_PURCHASE = 'usdc purchase',
  USDC_EXTRAS = 'usdc extras',
  TOKEN_GATED = 'token gated'
}
